module.exports = __webpack_public_path__ + "static/6-Yoga-415772a541494b560f62fffb4496b4dd.jpg";